<template>
    <PopupRouterView :showLeftIcon="true" label="Production Quality Inspection Visual Input"
        okTitle="Save"
        cancelTitle="Cancel"
        entityName="productionqualityinspectionvisual"
        :documentId="mainRecordId"
        @saveMethod="saveAction"
        @hideMethod="onHidden"
        ref="productionQualityInspectionVisualInput">


        <b-card header="Production Quality Inspection Visual" class="mb-3 card-max-width">
            <b-row>
				<b-col cols="12" lg="6">
						<app-label label-cols-lg="12" size="sm" type="generatednumber" label="Inspection Number" :model="model.inspectionNumber" />
						<app-input-combobox-autocomplete :options="workOrderProcessDetails" optionsLabel="part" optionsKey="id" label-cols-lg="12" label="Work Order Process Detail" id="fieldset-work-order-process-detail" size="sm" :model.sync="model.workOrderProcessDetailId"   :selected="model.workOrderProcessDetail != null ? model.workOrderProcessDetail.part : ''" @input="getWorkOrderProcessDetails" @change="updateData"  :isSelectMethodExists="true" @onSelectMethod="setSelectedWorkOrderProcessDetail" />
						<app-input-combobox-autocomplete :options="workOrderExecutionDetails" optionsLabel="workOrderProcessDetail" optionsKey="id" label-cols-lg="12" label="Work Order Execution Detail" id="fieldset-work-order-execution-detail" size="sm" :model.sync="model.workOrderExecutionDetailId"   :selected="model.workOrderExecutionDetail != null ? model.workOrderExecutionDetail.workOrderProcessDetail : ''" @input="getWorkOrderExecutionDetails" @change="updateData"  :isSelectMethodExists="true" @onSelectMethod="setSelectedWorkOrderExecutionDetail" />
						<app-input-datetimepicker id="fieldset-production-date" label-cols-lg="12"  label="ProductionDate" size="sm" :model.sync="model.productionDate"  :date-format-options="{ year: 'numeric', month: '2-digit', day: '2-digit' }" locale="en-GB" @change="updateData" />
						<app-input-combobox-autocomplete :options="parts" optionsLabel="partNumber" optionsKey="id" label-cols-lg="12" label="Part" id="fieldset-part" size="sm" :model.sync="model.partId"   :selected="model.part != null ? model.part.partNumber : ''" @input="getParts" @change="updateData"  :isSelectMethodExists="true" @onSelectMethod="setSelectedPart" />
					</b-col>
					<b-col cols="12" lg="6">
				</b-col>

            </b-row>
        </b-card>

		<app-table-input 
			title = "ProductionQualityInspectionVisualDetail"
			:bordered="true" :items="productionQualityInspectionVisualDetails" 
			:fields="fieldsProductionQualityInspectionVisualDetail" 
			:busy="isDataLoading" 
			:sort-by.sync="sortByProductionQualityInspectionVisualDetail" 
			:sort-desc.sync="sortDescProductionQualityInspectionVisualDetail" small responsive	
			@editButtonMethod="editRowDataProductionQualityInspectionVisualDetail"	
			@deleteButtonMethod="deleteRowDataProductionQualityInspectionVisualDetail"	
			@showPopupAddMethod="addDataProductionQualityInspectionVisualDetail()"	
			@showPopupUploadMethod="showPopupUploadProductionQualityInspectionVisualDetail()"
			@downloadMethod="downloadProductionQualityInspectionVisualDetail()"
			@addFromClipboardMethod="addFromClipboardProductionQualityInspectionVisualDetail()"
			@replaceFromClipboardMethod="replaceFromClipboardProductionQualityInspectionVisualDetail()"
			:showActionButton="true"
			:showDeleteButton="true"
			:showAddButton="true"
			:showAddFromClipboardButton="false"	
			:showReplaceFromClipboardButton="false"	
			:showUploadButton="true"	
			:showDownloadButton="true"	
			:isDownloadBusy="isDownloadProductionQualityInspectionVisualDetail"
		>
								
			<!-- <template v-slot:head(actions)>
				<b-button @click="isShowProductionQualityInspectionVisualDetailFilter = !isShowProductionQualityInspectionVisualDetailFilter" class="float-right" size="sm"><b-icon-funnel-fill /></b-button>
			</template> -->
								
			<template #top-row v-if="isShowProductionQualityInspectionVisualDetailFilter">
				<b-th></b-th>
				<b-th stacked-heading="Work Order Execution Ng">
					<v-select id="input-production-quality-inspection-visual-detail-work-order-execution-ng-table" append-to-body label="workOrderExecutionDetail" :options="workOrderExecutionNgs" :value="filterProductionQualityInspectionVisualDetail.workOrderExecutionNgId" :reduce="item => item.id" v-model="filterProductionQualityInspectionVisualDetail.workOrderExecutionNgId" @search="getWorkOrderExecutionNgs" :filterable ="true"></v-select>
				</b-th>
				<b-th stacked-heading="Ng Category">
					<v-select id="input-production-quality-inspection-visual-detail-problem-category-table" append-to-body label="code" :options="problemCategorys" :value="filterProductionQualityInspectionVisualDetail.problemCategoryId" :reduce="item => item.id" v-model="filterProductionQualityInspectionVisualDetail.problemCategoryId" @search="getProblemCategorys" :filterable ="true"></v-select>
				</b-th>
				<b-th stacked-heading="Ng Qty">
					<b-form-input id="input-production-quality-inspection-visual-detail-ng-qty-table" v-model="filterProductionQualityInspectionVisualDetail.ngQty" size="sm"></b-form-input>
				</b-th>

				<b-th></b-th>
			</template>
								
			<template v-slot:cell(no)="row">
				{{ ((row.index + 1) + ( productionQualityInspectionVisualDetailPageSize * (currentProductionQualityInspectionVisualDetailPage - 1))) }}
			</template>
								
			<template v-slot:table-busys>
				<div class="text-center my-2">
					<b-spinner class="align-middle text-primary"></b-spinner>
					<strong class="ml-2">Loading...</strong>
				</div>
			</template>
								
			<template v-slot:cell(workOrderExecutionNg)="row">
				<app-input-combobox-autocomplete :options="workOrderExecutionNgs" optionsLabel="workOrderExecutionDetail" optionsKey="id" :id="'input-production-quality-inspection-visual-detail-work-order-execution-ng-' + row.index" label-cols-lg="12" label="Work Order Execution Ng" size="sm" :model.sync="row.item.workOrderExecutionNgId"  @change="saveInputProductionQualityInspectionVisualDetail(row.item)" :selected="row.item.workOrderExecutionNg != null ? row.item.workOrderExecutionNg.workOrderExecutionDetail : ''"  @input="getWorkOrderExecutionNgs" :loading="isWorkOrderExecutionNgComboLoading"    :nolabel="true" />
			</template>
			<template v-slot:cell(problemCategory)="row">
				<app-input-combobox-autocomplete :options="problemCategorys" optionsLabel="code" optionsKey="id" :id="'input-production-quality-inspection-visual-detail-problem-category-' + row.index" label-cols-lg="12" label="Ng Category" size="sm" :model.sync="row.item.problemCategoryId"  @change="saveInputProductionQualityInspectionVisualDetail(row.item)" :selected="row.item.problemCategory != null ? row.item.problemCategory.code : ''"  @input="getProblemCategorys" :loading="isProblemCategoryComboLoading"    :nolabel="true" />
			</template>
			<template v-slot:cell(ngQty)="row">
				<app-input-textbox :id="'input-production-quality-inspection-visual-detail-ng-qty-' + row.index" label-cols-lg="12" label="Ng Qty" size="sm" :model.sync="row.item.ngQty"   @change="saveInputProductionQualityInspectionVisualDetail(row.item)"   :nolabel="true" />
			</template>

								
			<template v-slot:form-add-detail>
				<ProductionQualityInspectionVisualDetailInput 
					:model="modelProductionQualityInspectionVisualDetail"
					:openPopup="isShowPopupProductionQualityInspectionVisualDetail"
					@resetMethod="resetModal"
					@addButtonMethod="addRowDataProductionQualityInspectionVisualDetail"/>
			</template>
			<template v-slot:upload-detail>
					<ProductionQualityInspectionVisualDetailUpload
					:openPopup="isShowPopupUploadProductionQualityInspectionVisualDetail"
					@resetMethod="resetModal"
					@uploadButtonMethod="uploadDataProductionQualityInspectionVisualDetail"
					:parentId="modelId"
					/>
			</template>
			<!-- <template v-slot:table-paging>
				<b-pagination
				class="float-right btn-paging"
				v-model="currentProductionQualityInspectionVisualDetailPage"
				:total-rows="totalProductionQualityInspectionVisualDetailRow"
				:per-page="productionQualityInspectionVisualDetailPageSize"
				aria-controls="my-table"
				></b-pagination>
			</template> -->
		</app-table-input>


        <b-overlay :show="isBusy" no-wrap></b-overlay>
    </PopupRouterView>
</template><script>
import axios from 'axios';
import { validationMixin } from "vuelidate";
import { required, minLength } from "vuelidate/lib/validators";
import ProductionQualityInspectionVisual from '@/models/ProductionQualityInspectionVisual/ProductionQualityInspectionVisual';
import ProductionQualityInspectionVisualList from '@/models/ProductionQualityInspectionVisual/ProductionQualityInspectionVisualList';
import ProductionQualityInspectionVisualFilter from '@/filters/ProductionQualityInspectionVisual/ProductionQualityInspectionVisualFilter';

import AppLabel from '@/components/AppLabel';
import AppInputComboboxAutocomplete from '@/components/AppInputComboboxAutocomplete';
import WorkOrderProcessDetail from '@/models/WorkOrderProcess/WorkOrderProcessDetail';
import WorkOrderProcessDetailFilter from '@/filters/WorkOrderProcess/WorkOrderProcessDetailFilter';
import WorkOrderExecutionDetail from '@/models/WorkOrderExecution/WorkOrderExecutionDetail';
import WorkOrderExecutionDetailFilter from '@/filters/WorkOrderExecution/WorkOrderExecutionDetailFilter';
import AppInputDatetimepicker from '@/components/AppInputDatetimepicker';
import AppInputDatetimepickerRange from '@/components/AppInputDatetimepickerRange';
import Part from '@/models/Part/Part';
import PartFilter from '@/filters/Part/PartFilter';
import ProductionQualityInspectionVisualDetail from '@/models/ProductionQualityInspectionVisual/ProductionQualityInspectionVisualDetail';
import ProductionQualityInspectionVisualDetailFilter from '@/filters/ProductionQualityInspectionVisual/ProductionQualityInspectionVisualDetailFilter';
import WorkOrderExecutionNg from '@/models/WorkOrderExecutionNg/WorkOrderExecutionNg';
import WorkOrderExecutionNgFilter from '@/filters/WorkOrderExecutionNg/WorkOrderExecutionNgFilter';
import ProblemCategory from '@/models/ProblemCategory/ProblemCategory';
import ProblemCategoryFilter from '@/filters/ProblemCategory/ProblemCategoryFilter';
import AppInputTextbox from '@/components/AppInputTextbox';
import AppTableInput from '@/components/AppTableInput';
import AppTableInputPopup from '@/components/AppTableInputPopup';
import ProductionQualityInspectionVisualDetailInput from '@/views/ProductionQualityInspectionVisual/ProductionQualityInspectionVisualDetailInput';
import ProductionQualityInspectionVisualDetailUpload from '@/views/ProductionQualityInspectionVisual/ProductionQualityInspectionVisualDetailUpload';
import PopupRouterView from '@/components/PopupRouterView';
export default {
	components : {
		AppLabel,
		AppInputComboboxAutocomplete,
		AppInputDatetimepicker,
		AppInputDatetimepickerRange,
		AppInputTextbox,
		ProductionQualityInspectionVisualDetailInput,ProductionQualityInspectionVisualDetailUpload,
		AppTableInput,
		AppTableInputPopup,
		PopupRouterView,
	},
	mixins : [validationMixin],
	validations: {
		model: {
		},
	},
	data() {
		return {
			errorMessage : {
			},
			datas: Array(),
			selectAll:false,
			sortBy: '',
			sortDesc: '',
			pagingOptions:[
				{ value : '10', text : '10', selected:true },
				{ value : '25', text : '25' },
				{ value : '50', text : '50' },
				{ value : '100', text : '100' },
			],
			fieldsProductionQualityInspectionVisualDetail: [
				{"frontActions": { "class" : "th-actions", "label" : ""}},
				{"no" : { "class" : "th-number d-stack-none"}}, 
				{"workOrderExecutionNg": { "class" : "th-work-order-execution-ng first-child", "label" : "Work Order Execution Ng", key: 'workOrderExecutionNg', sortable: false}}, 
				{"problemCategory": { "class" : "th-problem-category", "label" : "Ng Category", key: 'problemCategory', sortable: false}}, 
				{"ngQty": { "class" : "th-ng-qty last-child", "label" : "Ng Qty", key: 'ngQty', sortable: false}}, 
				{"actions": { "class" : "th-actions d-stack-show", "label" : ""}}
			],
			busy:false,
			isBusy: false,
			isDataLoading: false,
			selected:'',
			pageSizeOptions: 10,
			pageIndex:0,
			sortingBy: Array(),
			modelId: null,
			model: {},
			modelProductionQualityInspectionVisualDetail : {},
			isShowPopupProductionQualityInspectionVisualDetail : false,
			isShowPopupUploadProductionQualityInspectionVisualDetail : false,
			filterProductionQualityInspectionVisual : null,
			currentProductionQualityInspectionVisualPage : 1,
			productionQualityInspectionVisualPageSize: 10,
			sortByProductionQualityInspectionVisual: '',
			sortDescProductionQualityInspectionVisual: '',
			filterProductionQualityInspectionVisualDetail : null,
			currentProductionQualityInspectionVisualDetailPage : 1,
			productionQualityInspectionVisualDetailPageSize: 10,
			sortByProductionQualityInspectionVisualDetail: '',
			sortDescProductionQualityInspectionVisualDetail: '',
			sortingByProductionQualityInspectionVisualDetail: [],
			productionQualityInspectionVisualDetails : [],
			productionQualityInspectionVisualDetailId : '',
			totalProductionQualityInspectionVisualDetailRow : 0,
			isShowProductionQualityInspectionVisualDetailFilter: false,
			isDownloadProductionQualityInspectionVisualDetail: false,
			workOrderExecutionNgs: [],
			problemCategorys: [],
			workOrderProcessDetails: [],
			workOrderProcessDetails: [],
			isWorkOrderProcessDetailComboLoading: false,
			workOrderExecutionDetails: [],
			workOrderExecutionDetails: [],
			isWorkOrderExecutionDetailComboLoading: false,
			parts: [],
			parts: [],
			isPartComboLoading: false,
			isShowPopupConfirmation : false,
			isDataCommited : false,
			mainRecordId : '',
			isWorkOrderProcessDetailComboLoading: false,
			isWorkOrderExecutionDetailComboLoading: false,
			isPartComboLoading: false,
			isProductionQualityInspectionVisualComboLoading: false,
			isWorkOrderExecutionNgComboLoading: false,
			isProblemCategoryComboLoading: false,
		}
	},
	methods : {
		getProductionQualityInspectionVisual : async function(id) {
			this.isBusy = true;
			ProductionQualityInspectionVisual.getData(this, id).then(result => {
				this.model = result;
				this.mainRecordId = String(result.mainRecordId);
				let promises = Array();


				Promise.all(promises).then((results) => {
					this.isBusy = false;
				});
			}).catch(error => { this.isBusy = false; });
		},
		downloadData() {
			this.isDownloadProductionQualityInspectionVisual = true;
			this.filterProductionQualityInspectionVisual.id = this.modelId;
			ProductionQualityInspectionVisual.downloadDataDetail(this, this.filterProductionQualityInspectionVisual).then(result => {
				this.isDownloadProductionQualityInspectionVisual = false;
			}).catch(error => { this.isDownloadProductionQualityInspectionVisual = false; })
		},
		getProductionQualityInspectionVisualDetails : async function(isAddRow) {
			let filter = {};
			Object.assign(filter, this.filterProductionQualityInspectionVisualDetail);
			if (this.modelId == null) return;
			filter.productionQualityInspectionVisualId = this.modelId;
			filter.draftMode = "1";
			if (this.sortByProductionQualityInspectionVisualDetail != null) {
				this.sortingByProductionQualityInspectionVisualDetail[this.sortByProductionQualityInspectionVisualDetail] = this.sortDescProductionQualityInspectionVisualDetail;
			}
			let currentPage = (this.currentProductionQualityInspectionVisualDetailPage - 1);
			if (isAddRow) {
				let totalData = this.totalProductionQualityInspectionVisualDetailRow + 1;
				let page = Math.ceil(totalData/this.productionQualityInspectionVisualDetailPageSize);
				currentPage = page - 1;
			}
			// disable paging start
			currentPage = null;
			this.productionQualityInspectionVisualDetailPageSize = 0;
			// disable paging end
			ProductionQualityInspectionVisualDetail.getList(this, filter, this.sortingByProductionQualityInspectionVisualDetail, currentPage , this.productionQualityInspectionVisualDetailPageSize).then(result => {
				this.currentProductionQualityInspectionVisualDetailPage = currentPage + 1;
				this.productionQualityInspectionVisualDetails = result.data;
				this.totalProductionQualityInspectionVisualDetailRow = result.dataCount;
			}).catch(error => {});
		},
		getProductionQualityInspectionVisuals : async function(input) {
			let filter = new ProductionQualityInspectionVisualFilter();
			if (input != undefined) {
				filter.InspectionNumber = input;
			}
			this.isProductionQualityInspectionVisualComboLoading = true;
			ProductionQualityInspectionVisual.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.productionQualityInspectionVisuals = result.data
				}
				this.isProductionQualityInspectionVisualComboLoading = false;
			})
			.catch(error => {});
		},
		getProductionQualityInspectionVisuals : async function(input) {
			let filter = new ProductionQualityInspectionVisualFilter();
			if (input != undefined) {
				filter.inspectionNumber = input;
			}
			this.isProductionQualityInspectionVisualComboLoading = true;
			ProductionQualityInspectionVisual.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.productionQualityInspectionVisuals = result.data
				}
				this.isProductionQualityInspectionVisualComboLoading = false;
			})
			.catch(error => {});
		},
		getWorkOrderExecutionNgs : async function(input) {
			let filter = new WorkOrderExecutionNgFilter();
			if (input != undefined) {
				filter.workOrderExecutionDetail = input;
			}
			this.isWorkOrderExecutionNgComboLoading = true;
			WorkOrderExecutionNg.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.workOrderExecutionNgs = result.data
				}
				this.isWorkOrderExecutionNgComboLoading = false;
			})
			.catch(error => {});
		},
		getProblemCategorys : async function(input) {
			let filter = new ProblemCategoryFilter();
			if (input != undefined) {
				filter.code = input;
			}
			this.isProblemCategoryComboLoading = true;
			ProblemCategory.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.problemCategorys = result.data
				}
				this.isProblemCategoryComboLoading = false;
			})
			.catch(error => {});
		},
		getWorkOrderProcessDetails : async function(input) {
			let filter = new WorkOrderProcessDetailFilter();
			if (input != undefined) {
				filter.part = input;
			}
			WorkOrderProcessDetail.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.workOrderProcessDetails = result.data
				}
			})
			.catch(error => {});
		},
		setSelectedWorkOrderProcessDetail(item) {
			if(item == undefined || item == null) {
				this.model.workOrderProcessDetailId = null;
				this.model.workOrderProcessDetail = null;
			} else {
				this.model.workOrderProcessDetailId = item.id;
				this.model.workOrderProcessDetail = item;
			}
			this.$forceUpdate();
			this.updateData();
		},
		getWorkOrderExecutionDetails : async function(input) {
			let filter = new WorkOrderExecutionDetailFilter();
			if (input != undefined) {
				filter.workOrderProcessDetail = input;
			}
			WorkOrderExecutionDetail.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.workOrderExecutionDetails = result.data
				}
			})
			.catch(error => {});
		},
		setSelectedWorkOrderExecutionDetail(item) {
			if(item == undefined || item == null) {
				this.model.workOrderExecutionDetailId = null;
				this.model.workOrderExecutionDetail = null;
			} else {
				this.model.workOrderExecutionDetailId = item.id;
				this.model.workOrderExecutionDetail = item;
			}
			this.$forceUpdate();
			this.updateData();
		},
		getParts : async function(input) {
			let filter = new PartFilter();
			if (input != undefined) {
				filter.partNumber = input;
			}
			Part.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.parts = result.data
				}
			})
			.catch(error => {});
		},
		setSelectedPart(item) {
			if(item == undefined || item == null) {
				this.model.partId = null;
				this.model.part = null;
			} else {
				this.model.partId = item.id;
				this.model.part = item;
			}
			this.$forceUpdate();
			this.updateData();
		},
		validateState(name) {
			if (!this.$v.model[name]) return null;
			const { $dirty, $error } = this.$v.model[name];
			return $dirty ? !$error : null;
		},
		getErrorMessage(message, name) {
			if (!this.$v.model[name]) return "";
			if (this.$v.model[name].required != undefined && !this.$v.model[name].required) {
				if (message.required) return message.required;
			}
		},
		handleScroll() {
			this.$refs.productionQualityInspectionVisualInput.scrollTop = 0;
		},
		saveAction(modalEvent) {
			modalEvent.preventDefault();
			this.handleScroll();
			let id = this.$route.params.id;
			this.$v.model.$touch(); 
			if (this.$v.model.$anyError) {
				return;
			} else {
				this.isBusy = true;
				let id = this.modelId;
				let model = this.model;

				if (id != '' && id != null && id != undefined) {
					ProductionQualityInspectionVisual.commitData(this, model, id).then(result => {
						this.isDataCommited = true;
						this.$router.push({ name: 'productionqualityinspectionvisualindex' });
						this.isBusy = false;
					}).catch(error => { this.isBusy = false; });
				} else {
					ProductionQualityInspectionVisual.insertData(this, model).then(result => {
						this.isDataCommited = true;
						this.$router.push({ name: 'productionqualityinspectionvisualindex' });
						this.isBusy = false;
					}).catch(error => { this.isBusy = false; });
				}
			}
		},
		updateData() {
			let id = this.modelId;
			let model = this.model;
			let promises = Array();

			Promise.all(promises).then((results) => {
				if (id != '' && id != null && id != undefined) {
					ProductionQualityInspectionVisual.updateData(this, model, id)
					.catch((error) => {
						this.getProductionQualityInspectionVisual(id);
					});
				}
			});
		},
		onHidden() {
			this.getProductionQualityInspectionVisuals();
		},
		addRowDataProductionQualityInspectionVisualDetail(modalEvent, model) {
			if (model != null) {
				if (model.id != null && model.id != '') {
					model.productionQualityInspectionVisualId =  this.modelId;
					ProductionQualityInspectionVisualDetail.updateDataDetail(this, model, model.id)
					.then(result => {
						this.getProductionQualityInspectionVisualDetails(true);
						this.isShowPopupProductionQualityInspectionVisualDetail = false;
					})
				} else {
					model.productionQualityInspectionVisualId =  this.modelId;
					ProductionQualityInspectionVisualDetail.createDataDetail(this, model)
					.then(result => {
						this.getProductionQualityInspectionVisualDetails(true);
						this.isShowPopupProductionQualityInspectionVisualDetail = false;
					})
				}
			}
		},
		async editRowDataProductionQualityInspectionVisualDetail(id) {
			this.productionQualityInspectionVisualDetailId = id;
			this.isShowPopupProductionQualityInspectionVisualDetail = true; 
		},
		async deleteRowDataProductionQualityInspectionVisualDetail(id) {
			ProductionQualityInspectionVisualDetail.deleteData(this, id).then(result => { this.getProductionQualityInspectionVisualDetails(); });
		},
		async resetDataProductionQualityInspectionVisualDetail() {
			this.productionQualityInspectionVisualDetailId = "";
			this.isShowPopupProductionQualityInspectionVisualDetail = true;
		},
		async addDataProductionQualityInspectionVisualDetail() {
			ProductionQualityInspectionVisualDetail.createData(this, { productionQualityInspectionVisualId: this.modelId })
			.then(result => {
				this.getProductionQualityInspectionVisualDetails(true);
			})
		},
		async addFromClipboardProductionQualityInspectionVisualDetail() {
			let workOrderExecutionNgs = new Array();
			navigator.clipboard.readText().then(value => {
				if(value.match(/(?:\r\n|\r|\n)/g)) { value=value.replace(/(?:\r\n|\r|\n)/g, ',') ; }
				let values = value.split(",");
				values.forEach(item => {
					workOrderExecutionNgs.push({ workOrderExecutionNg: item, productionQualityInspectionVisualId: this.modelId });
				});
				ProductionQualityInspectionVisualDetail.addFromClipboard(this, workOrderExecutionNgs).then(result => { this.getProductionQualityInspectionVisualDetails() });
			});
		},
		async replaceFromClipboardProductionQualityInspectionVisualDetail() {
			let workOrderExecutionNgs = new Array();
			navigator.clipboard.readText().then(value => {
				if(value.match(/(?:\r\n|\r|\n)/g)) { value=value.replace(/(?:\r\n|\r|\n)/g, ',') ; }
				let values = value.split(",");
				values.forEach(item => {
					workOrderExecutionNgs.push({ workOrderExecutionNg: item, productionQualityInspectionVisualId: this.modelId });
				});
				ProductionQualityInspectionVisualDetail.replaceFromClipboard(this, workOrderExecutionNgs).then(result => { this.getProductionQualityInspectionVisualDetails() });
			});   
		},
		showPopupUploadProductionQualityInspectionVisualDetail() {
			if(this.productionQualityInspectionVisualDetails != null && this.productionQualityInspectionVisualDetails.length > 0) {
				const msg = this.$createElement;
				const msgNode = msg('div', {
					domProps: {
						innerHTML: '<p>Perubahan terhadap ProductionQualityInspectionVisualDetail akan me-reset data yang sudah diinput sebelumnya.</p><p>Apakah anda yakin akan melanjutkan?</p>'
					}
				});
				this.$bvModal.msgBoxConfirm([msgNode], {
					title: 'Confirmation',
					size: 'sm',
					buttonSize: 'sm',
					okVariant: 'success',
					cancelVariant: 'danger',
					okTitle: 'Yes',
					cancelTitle: 'No',
					footerClass: 'p-2',
					hideHeaderClose: false,
					centered: true
				})
				.then(value => {
					if (value) {
						this.isShowPopupUploadProductionQualityInspectionVisualDetail = true;
					}
				})
				.catch(err => {})
			} else {
				this.isShowPopupUploadProductionQualityInspectionVisualDetail = true;
			}
		},
		uploadDataProductionQualityInspectionVisualDetail(modalEvent, newDatas) {
			this.isShowPopupUploadProductionQualityInspectionVisualDetail = false; 
		},
		downloadProductionQualityInspectionVisualDetail(modalEvent) {
			this.isDownloadProductionQualityInspectionVisualDetail = true;
			this.filterProductionQualityInspectionVisualDetail.productionQualityInspectionVisualId = this.modelId;
			ProductionQualityInspectionVisualDetail.downloadDataDetail(this, this.filterProductionQualityInspectionVisualDetail).then(result => {
				this.isDownloadProductionQualityInspectionVisualDetail = false;
			}).catch(error => { this.isDownloadProductionQualityInspectionVisualDetail = false; })
		},
		saveInputProductionQualityInspectionVisualDetail(item) {
			if (this.productionQualityInspectionVisuals != null && this.productionQualityInspectionVisuals != undefined  && this.productionQualityInspectionVisuals.length > 0) {
				item.productionQualityInspectionVisual = this.productionQualityInspectionVisuals.find(q => q.id == item.productionQualityInspectionVisualId);
			}
			if (this.workOrderExecutionNgs != null && this.workOrderExecutionNgs != undefined  && this.workOrderExecutionNgs.length > 0) {
				item.workOrderExecutionNg = this.workOrderExecutionNgs.find(q => q.id == item.workOrderExecutionNgId);
			}
			if (this.problemCategorys != null && this.problemCategorys != undefined  && this.problemCategorys.length > 0) {
				item.problemCategory = this.problemCategorys.find(q => q.id == item.problemCategoryId);
			}

			let id = item.id;
			let promises = Array();

			Promise.all(promises).then((results) => {
				if (id != '' && id != null && id != undefined) {
					ProductionQualityInspectionVisualDetail.updateData(this, item, item.id);
				}
			});
		},
		resetModal(modalType) {
			this.isShowPopupUploadProductionQualityInspectionVisualDetail = false; 
			this.isShowPopupProductionQualityInspectionVisualDetail = false; 
			if (modalType == 'ProductionQualityInspectionVisualDetail') {
				this.getProductionQualityInspectionVisualDetails();
			}
			this.showPopupCopyData = false; 
			this.isShowPopupConfirmation = false;
		},
		displayFilter() {
			this.windowWidth = window.innerWidth;
			if (this.windowWidth <= 768 ) {
				//this.isShowProductionQualityInspectionVisualDetailFilter = true;
			}
		},
	},
	beforeMount() {
		this.filterProductionQualityInspectionVisual = new ProductionQualityInspectionVisualFilter();
		this.filterProductionQualityInspectionVisualDetail = new ProductionQualityInspectionVisualDetailFilter();
		//this.getProductionQualityInspectionVisuals();
		//this.getWorkOrderExecutionNgs();
		//this.getProblemCategorys();
		//this.getWorkOrderProcessDetails();
		//this.getWorkOrderExecutionDetails();
		//this.getParts();
	},
	async mounted(){
		let id = this.$route.params.id;
		let copyData = this.$route.params.copydata;
		if (id != '' && id != null && id != undefined) {
			if (copyData != null && copyData != undefined) {
				this.getProductionQualityInspectionVisual(id);
			} else {
				this.modelId = id;
				this.getProductionQualityInspectionVisual(id);
			}
		}
		this.$nextTick(() => {
			window.addEventListener('resize', this.displayFilter);
			this.displayFilter();
		});
	},
	computed: {
		isAllowSaveDraft: {
			get: function() {
				return true;
			}
		}
	},
	watch : {
		sortByProductionQualityInspectionVisualDetail : {
			handler: function() {
				this.getProductionQualityInspectionVisualDetails();
			}
		},
		sortDescProductionQualityInspectionVisualDetail: {
			handler: function() {
				this.getProductionQualityInspectionVisualDetails();
			}
		},
		currentProductionQualityInspectionVisualDetailPage: {
			handler: function() {
				this.getProductionQualityInspectionVisualDetails();
			}
		},
		productionQualityInspectionVisualDetailPageSize : {
			handler: function() {
				this.getProductionQualityInspectionVisualDetails();
			}
		},
		filterProductionQualityInspectionVisualDetail: {
			handler: function() {
				this.getProductionQualityInspectionVisualDetails();
			},
			deep: true,
		},
	},
}
</script>
